<div class="main-content" style="margin:0px !important; padding:0px !important;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12" style="padding:0px;">
                <div class="card">
                    <!--<div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>-->
          <!--------------------------------toolBox---------------------------------->

                    <div class="container-fluid">
                        <div class="row">
                            <!--<div class="col-md-2">
                                <div class="toolBox">
                                    <div class="accordion">
                                        <div class="row accordion-header">
                                            <div class="col-12">
                                                <h5>Toolbox</h5>
                                            </div>
                                        </div>
                                        <div class="row accordion-content-active">
                                            <div class="col-12">
                                                <p>Fields</p>
                                            </div>
                                        </div>
                                        <div class="row accordion-content">
                                            <div class="col-12">
                                                <div class="fields">
                                                    <span class='field'>&#123;Student Name&#125;</span>
                                                    <span class='field'>&#123;Coach Name&#125;</span>
                                                    <span class='field'>&#123;Niche&#125;</span>
                                                    <span class='field'>Report Url</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row accordion-content-active">
                                            <div class="col-12">
                                                <p>Images</p>
                                            </div>
                                        </div>
                                        <div class="row accordion-content">
                                            <div class="col-12">
                                                <div class="images">
                                                    <div>
                                                        <div class="cust-image"></div>
                                                        <p>iPEC's logo</p>
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <div class="cust-image"></div>
                                                        <p>Coaches logo</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>-->

        <!--------------------------------toolBox END----------------------------------->

        <!--------------------------------main-content---------------------------------->
                            <div class="col-md-12">
                                <div class="main-container">

                                    <div class="myheader">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <!--<h3>Email template</h3>-->
                                            </div>
                                            <div class="col-md-6">
                                                <div class="text-right">
                                                    <i class="material-icons">email</i>
                                                    <i class="material-icons">dashboard</i>
                                                    <i [routerLink]="['/app/emailtemplates']" title="save" class="material-icons">save</i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="panel-group" id="accordion">
                                        <div class="panel panel-default">
                                            <div class="panel-heading fieldsTitle" id="{{fieldsOpen}}" data-toggle="collapse" data-parent="#accordion" href="#collapse" (click)="changeTitle(fieldsOpen)">
                                                <h4 class="panel-title">
                                                    <a>
                                                        Fields
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapse" class="panel-collapse collapse in">
                                                <div class="panel-body">
                                                    <div class="panel-body">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label>Name: </label>
                                                                <input type="text" name="name" value="{{name}}" />
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label>Assessment type: </label>
                                                                <select #_type (change)="changeType(_type.value)">
                                                                    <option  *ngFor="let _type of types" [selected]="type == _type" value="{{_type}}">{{_type}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <!--<div class="row">
                                                            <div class="col-12">
                                                                <label>Niche: </label>
                                                                <select #_niche (change)="changeNiche(_niche.value)">
                                                                    <option *ngFor="let _niche of niches" [selected]="niche == _niche" value="{{_niche}}">{{_niche}}</option>
                                                                </select>
                                                            </div>
                                                        </div>-->

                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label>Purpose: </label>
                                                                <select #_purpose (change)="changePurpose(_purpose.value)">
                                                                    <option *ngFor="let _purpose of purposes" [selected]="purpose == _purpose" value="{{_purpose.Id}}">{{_purpose.Name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label>Language: </label>
                                                                <select>
                                                                    <option selected="selected" class="option">English</option>
                                                                    <option class="option">Spanish</option>
                                                                    <option class="option">French</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label>Subject: </label>
                                                                <input type="text" name="subject" value="" placeholder="Subject" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="panel panel-default">
                                                <div class="panel-heading" data-toggle="collapse" data-parent="#accordion" href="#collapseEditor">
                                                    <h4 class="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseEditor">
                                                            Body
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseEditor" class="panel-collapse collapse in">
                                                    <div class="panel-body">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <!--<label>Body: </label>-->
                                                                <div class="body-content">
                                                                    <!--Dear <span class='field'>&#123;Student Name&#125;</span><br />
                                                                    <span class='field'>&#123;Coach Name&#125;</span>
                                                                    is inviting you to fulfill the following assessment ...-->
                                                                    <div [froalaEditor]='options'></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                    <br />

                                    <!--<div class="row">
                                        <div class="col-12">
                                            <div class="my-icons">
                                                <i class="material-icons">format_bold</i>
                                                <i class="material-icons">format_italic</i>
                                                <i class="material-icons">format_underlined</i>
                                                <i class="material-icons">format_list_bulleted</i>
                                                <i class="material-icons">format_list_numbered</i>
                                            </div>
                                        </div>
                                    </div>-->

                                    <br />
                                    
                                    <br />
                                </div>
                            </div>
        <!--------------------------------main-content END---------------------------------->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
